import { useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
// import Lenis from 'lenis'
// Compents
import Header from '../components/header'
import Footer from '../components/footer'

function Contact() {



  const [formData, setFormData] = useState({
    form_name: "",
    form_email: "",
    form_phone: "",
    form_subject: "",
    form_message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("https://mystra.in/apiMail/indus-bookappoinment.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams(formData)
      });

      const result = await response.json();

      if (result.status === "success") {
        toast.success("✅ Message sent successfully!");

        // Reset form
        setFormData({
          form_name: "",
          form_email: "",
          form_phone: "",
          form_subject: "",
          form_message: ""
        });

      } else {
        toast.error("❌ " + result.message);
      }

    } catch (error) {
      console.error(error);
      toast.error("⚠️ Something went wrong");
    }

    setLoading(false);
  };


    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
                                  <ToastContainer
    position="bottom-right"
    autoClose={3000}
    hideProgressBar={false}
    closeOnClick
    pauseOnHover
    draggable
    theme="colored"
  />

<section className="breadcrumb-area">
	<div className="container text-center">
          <div className="sec-title">
            <h1 className="title-anim"><span>Contact Us</span></h1>
        </div>
	</div>
</section>

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Contact Us</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start contact area--> */}
<section className="contact-area">
    <div className="container">
        <div className="row">
            <div className="col-md-4">
                <div className="contact-info">
                    {/* <div className="title">
                        <h2>Quick Contact</h2>
                    </div> */}
                    <div className="accordion-box">
                        {/* <!--Start single accordion box--> */}
                        <div className="accordion accordion-block">
                            {/* <div className="accord-btn active"><h4>Headquarters</h4></div> */}
                            <div className="accord-content collapsed">
                                <ul className="contact-info-list">
                                     
                                    <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-technology"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>Call Us</span><br/>+91-44 24890169 & 24890057</h5>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-interface"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>Mail Us</span><br/>dirsales@indusref.com</h5>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-clock"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>Opening Time</span><br/>Mon - Sat: 9am to 6pm</h5>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-pin"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5>
                                                <span>Regd. Office:</span> <br/>Plot No.6, V.R.B. Avenue,<br/> 
                                                VRB Complex, First Floor(FA),<br/> 
                                                DR. Kanu Nagar Main Rd, <br/>
                                                Nesapakkam, Chennai, <br/>
                                                India – 600078.<br/>
                                                <strong>CIN NO:</strong> U29191TN1999PTC042117
                                            </h5>
                                        </div>
                                    </li>
                                     <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-pin"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>Factory:</span> <br/>Plot No.90, Industrial Park,<br/>
Valasapalle, Madanapalle Mandal, <br/>
Chottoor District,<br/>
Andhra Pradesh, <br/>
India – 517325.</h5>
                                        </div>
                                    </li>
                                     {/* <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-pin"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>Branch Office AP:</span>  <br/>
7-4-4A, Narsiah Agraharam,<br/>
Bhimavaram, <br/>
Andhra Pradesh -534 201.</h5>
                                        </div>
                                    </li> */}

                                 
                                </ul>
                            </div>
                        </div>
                        {/* <!--End single accordion box--> */}
                        {/* <!--Start single accordion box--> */}
                        {/* <div className="accordion accordion-block">
                            <div className="accord-btn" onClick={() => toggleSection(1)}><h4>Support Centre</h4></div>
                            <div className="accord-content">
                                <ul className="contact-info-list">
                                    <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-pin"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>226, Breaking Street,</span><br/> 2nd cros, Newyork ,USA 1002</h5>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-technology"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>Call Us</span><br/>+321 4567 89 012 &amp; 79 023</h5>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-interface"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>Mail Us</span><br/>Support@aircare.com</h5>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-holder">
                                            <span className="flaticon-clock"></span>
                                        </div>
                                        <div className="text-holder">
                                            <h5><span>Opening Time</span><br/>Mon - Sat: 09.00am to 18.00pm</h5>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                        {/* <!--End single accordion box-->  */}
                    </div>
                </div>
            </div>
            <div className="col-md-8">
                <div className="contact-form">
                    <div className="title">
                        <h2>Send Message Us</h2>
                    </div>
                    <form id="contact-form" name="contact_form" className="default-form" onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                                <input type="text" name="form_name" value={formData.form_name} onChange={handleChange} placeholder="Your Name*" required=""/>
                            </div>
                            <div className="col-md-6">
                                <input type="email" name="form_email" value={formData.form_email} onChange={handleChange} placeholder="Your Mail*" required=""/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <input type="text" name="form_phone" value={formData.form_phone} onChange={handleChange} placeholder="Phone"/>
                            </div>
                            <div className="col-md-6">
                                <input type="text" name="form_subject" value={formData.form_subject} onChange={handleChange} placeholder="Subject"/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <textarea name="form_message" value={formData.form_message} onChange={handleChange} placeholder="Your Message.." required=""></textarea>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <input id="form_botcheck" name="form_botcheck" className="form-control" type="hidden" value=""/>
                                <button className="thm-btn bg-1" type="submit" disabled={loading}>{loading ? "Please wait..." : "Send Message"}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
{/* <!--End contact area--> */}

{/* <!--Start Google map area--> */}
{/* <section className="google-map-area">
    <div 
        className="google-map" 
        id="contact-google-map" 
        data-map-lat="44.529688" 
        data-map-lng="-72.933009" 
        data-icon-path="assets/images/resources/map-marker.png" 
        data-map-title="Brooklyn, New York, United Kingdom" 
        data-map-zoom="12" 
        data-markers='{
            "marker-1": [44.529688, -72.933009, "<h4>Head Office</h4><p>44/108 Brooklyn, UK</p>"],
            "marker-2": [44.231172, -76.485954, "<h4>Branch Office</h4><p>4/99 Alabama, USA</p>"]
        }'>

    </div>
</section> */}
{/* <!--End Google map area-->     */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Contact;



 
